module.exports = __webpack_public_path__ + "img/home_img_4.3ea0efe4.webp";